var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElectronics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.5,
    height: 20.5,
    viewBox: "0 0 15.5 20.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "electronics-transister-svgrepo-com",
    d: "M7,16V3.6A.6.6,0,0,1,7.6,3h8.8a.6.6,0,0,1,.6.6V16M7,16H9M7,16H5m12,0H15m2,0h2m-7,0v6m0-6H9m3,0h3M9,16v6m6-6v6",
    transform: "translate(-4.25 -2.25)",
    fill: "none",
    stroke: "currentcolor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectronics);
export default __webpack_public_path__ + "static/media/electronics.55a517d750eb153ec33e2358b5632389.svg";
export { ForwardRef as ReactComponent };